import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { HttpClientModule, HttpClientJsonpModule } from '@angular/common/http';
import { ApiService } from './shared/api';
import { IonicStorageModule } from '@ionic/storage-angular';

import { authInterceptorProviders } from './shared/auth.interceptor';
import { DashboardPageModule } from './dashboard/dashboard.module';
import { TextConstantsService } from './shared/text-constants';
import { HeaderComponent } from './shared/components/header/header.component';
import { ChatApiService } from './shared/chat-api.service';
import { FormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { PasswordResetComponent } from './login/password-reset/password-reset.component';
import { DateSelectorModule } from './dashboard/components/date-selector/date-selector.module';

@NgModule({
  declarations: [
    AppComponent, 
    HeaderComponent, 
    LoginComponent, 
    PasswordResetComponent,
  ],
  imports: [
    BrowserModule, 
    IonicModule.forRoot(
      {
        mode: 'ios'
      }
    ),
    AppRoutingModule,
    HttpClientModule,
    HttpClientJsonpModule,
    IonicStorageModule.forRoot(),
    DashboardPageModule,
    FormsModule,
    DateSelectorModule
  ],
  providers: [
    { 
      provide: RouteReuseStrategy, 
      useClass: IonicRouteStrategy, 
    },
    ApiService,
    ChatApiService,
    authInterceptorProviders,
    TextConstantsService,
    LoginComponent,
    PasswordResetComponent,

  ],
  bootstrap: [AppComponent],
  exports: [
    LoginComponent,
    PasswordResetComponent,

  ]
})
export class AppModule {}
